import React, { useState, useEffect } from "react";

export const CandidateDetailsFooter = ({ candidate }) => {
  const [candidateData, setCandidateData] = useState(null);

  useEffect(() => {
    if (candidate) {
      setCandidateData(candidate?.candidateSubmissionData);
    }
  }, [candidate]);

  return (
    <div
      className="d-flex flex-row justify-content-between align-items-start my-4"
      style={{ width: "75%" }}
    >
      <div className="d-flex flex-column">
        <div className="d-flex flex-row gap-1">
          <span className="h3">I'm</span>
          <span className="h3" style={{ color: "#3256ED" }}>
            {candidateData?.firstName} {candidateData?.lastName}
          </span>
        </div>
        <h3>{candidateData?.currentPositionTitle}</h3>
        <div className="d-flex flex-row gap-1">
          <span className="h4">{candidateData?.totalExperience} Years</span>
          <span className="h4 fw-light">Experience</span>
        </div>
      </div>
      <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row align-items-center gap-2">
          <div
            className="d-flex justify-content-center align-items-center rounded-circle"
            style={{
              width: "25px",
              height: "25px",
              backgroundColor: "#E7E9EB",
              color: "#141313",
            }}
          >
            <span className="mdi mdi-phone"></span>
          </div>
          <span>
            {candidateData?.phoneCode} {candidateData?.phone}
          </span>
        </div>
        <div className="d-flex flex-row align-items-center gap-2">
          <div
            className="d-flex justify-content-center align-items-center rounded-circle"
            style={{
              width: "25px",
              height: "25px",
              backgroundColor: "#E7E9EB",
              color: "#141313",
            }}
          >
            <span className="mdi mdi-mail"></span>
          </div>
          <span>{candidateData?.email}</span>
        </div>
        <div className="d-flex flex-row align-items-center gap-2">
          <div
            className="d-flex justify-content-center align-items-center rounded-circle"
            style={{
              width: "25px",
              height: "25px",
              backgroundColor: "#E7E9EB",
              color: "#141313",
            }}
          >
            <span className="mdi mdi-map-marker"></span>
          </div>
          <span>{candidateData?.candidateNationality}</span>
        </div>
      </div>
    </div>
  );
};
